import i18next from "i18next";
import { toast } from "react-toastify";

import { customerDashboardServices } from "../../services";
import {
  ROUTES,
  messages,
  loginConstants,
  customerConstants,
  globalSystemConstants,
} from "../../constants";
import {
  customToast,
  errorHandler,
  formatGalleryItemData,
} from "../../shared/utility";
import { NavigateToPath } from "../../system";
import { success, failure, custom } from "./utilities";

// Event request tab actions
const myEvents = (id, status, pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .getMyEvents(id, status, pageNumber, pageSize)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.GET_MY_EVENTS));
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, customerConstants.GET_MY_EVENTS));
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const getExtendedEventDetails = (eventId) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .getExtendedEventDetails(eventId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.EXTEND_SHUTTERB));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const getTippedEventDetails = (eventId) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .getTippedEventDetails(eventId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.TIP_SHUTTERB));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const extendSbCheckout = (eventId, dataObj, cartPreviousScreen, history) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .getExtendSbCheckout(eventId, dataObj, cartPreviousScreen)
      .then(
        (response) => {
          NavigateToPath(history, ROUTES.EVENT_BOOKING);
          dispatch(success(response, customerConstants.EXTEND_SHUTTERB_CART));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

// Event request dashboard's actions it's same for both components AccessGAllery and SharedGallery
const myEventsAccessGallery = (
  eventId,
  groupEventId,
  setFiles,
  componentName
) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .getAccessGallery(eventId, groupEventId, componentName)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.MY_EVENTS_GALLERY));

          const items = response.items;
          // Check if items is an array
          if (Array.isArray(items)) {
            const updatedItems = items.map((item) => ({
              ...item,
              gallery: Array.isArray(item.gallery)
                ? item.gallery.map(formatGalleryItemData)
                : item.gallery,
            }));
            setFiles(updatedItems);
          } else {
            if (Array.isArray(items?.gallery)) {
              const updatedGallery = items.gallery.map(formatGalleryItemData);
              setFiles(updatedGallery);
            }
          }
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, customerConstants.MY_EVENTS_GALLERY));
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

// delete from gallery
const deleteFromGallery = (data, setSelectedFiles, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.DELETE_FROM_GALLERY,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .deleteFromGallery(data)
      .then(
        (response) => {
          if (onSuccess) {
            onSuccess();
          }
          setSelectedFiles([]);
          customToast(
            i18next.t("file_successfully_deleted"),
            toast.TYPE.SUCCESS
          );
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, customerConstants.DELETE_FROM_GALLERY));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.DELETE_FROM_GALLERY,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const lockFromGallery = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.LOCK_FROM_GALLERY,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .lockFromGallery(data)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.LOCK_FROM_GALLERY));
          if (onSuccess) {
            onSuccess();
          }
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, customerConstants.LOCK_FROM_GALLERY));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.LOCK_FROM_GALLERY,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

// same action for both components extend sb and tip sb
const getReviewFormData = (eventId) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.GET_REVIEW_FORM_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .getReviewFormData(eventId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.GET_REVIEW_FORM_DATA));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.GET_REVIEW_FORM_DATA,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const submitRatingAndFeedback = (data) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.SUBMIT_RATING_AND_FEEDBACK,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .submitRatingAndFeedback(data)
      .then(
        (response) => {
          dispatch(
            success(response, customerConstants.SUBMIT_RATING_AND_FEEDBACK)
          );
          dispatch(getReviewFormData(data[0].eventId));
          customToast(
            i18next.t("review_submit_successfully"),
            toast.TYPE.SUCCESS
          );
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.SUBMIT_RATING_AND_FEEDBACK,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

// my account tab actions
const updateCustomerPassword = (userId, dataObj) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .updateCustomerPassword(userId, dataObj)
      .then(
        (response) => {
          customToast(
            i18next.t(response),
            response.includes("not") ? toast.TYPE.ERROR : toast.TYPE.SUCCESS
          );
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const myAccountInfo = (userId) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .getMyAccountInfo(userId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.GET_MY_ACCOUNT_INFO));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const updateMyAccountInfo = (userId, dataObj, onResponseCallback) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .updateMyAccountInfo(userId, dataObj)
      .then(
        (response) => {
          if (onResponseCallback) {
            onResponseCallback();            
            dispatch(success(response?.items?.currentAddress, loginConstants.UPDATE_CURRENT_ADDRESS));
          }
          customToast(i18next.t("updated_successfully"), toast.TYPE.SUCCESS);
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

// Attended events tab actions
// Event request tab actions
const attendedEventSearchResult = (eventId, userId) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .getAttendedEventSearchResult(eventId, userId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.GET_SEARCH_RESULT));
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, customerConstants.GET_MY_EVENTS));
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const attendedEventRecentSearches = (userId) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .getAttendedEventRecentSearches(userId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.GET_RECENT_SEARCHES));
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, customerConstants.GET_MY_EVENTS));
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

// refer a friend tab
const referAFriend = (dataObj) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .referAFriend(dataObj)
      .then(
        (response) => {
          customToast(i18next.t(response), toast.TYPE.SUCCESS);
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const generateInvoice = (eventGroupId, invoiceId) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.GET_INVOICE,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .generateInvoice(eventGroupId, invoiceId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.GET_INVOICE));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.GET_INVOICE,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const downloadSelectedFiles = (eventIdsArr) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .downloadSelectedFiles(eventIdsArr)
      .then(
        (message) => {
          toast.success(i18next.t("download_files_email"), {
            autoClose: 5000,
            hideProgressBar: true,
          });
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const cancelEvent = (dataObj, status, pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .cancelEvent(dataObj)
      .then(
        (response) => {
          dispatch(myEvents(dataObj.userId, status, pageNumber, pageSize));
          dispatch(success(response, customerConstants.CANCEL_EVENT));
          customToast(
            i18next.t("event_cancel_successfully"),
            toast.TYPE.SUCCESS
          );
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, customerConstants.CANCEL_EVENT));
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

// Favorite gallery clip
const favoriteClip = (clipId, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.FAVORITE_GALLERY_CLIP,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .favoriteClip(clipId)
      .then(
        (response) => {
          // Call only on success
          if (onSuccess) {
            onSuccess();
          }
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, customerConstants.FAVORITE_GALLERY_CLIP));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.FAVORITE_GALLERY_CLIP,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const resetMyEvents = () => {
  return (dispatch) => {
    dispatch(custom(null, customerConstants.TAb_CHANGED));
  };
};

const getAccessGroupGallery = (groupEventId, setFiles) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    customerDashboardServices
      .getAccessGroupGallery(groupEventId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.MY_EVENTS_GALLERY));

          const items = response.items;
          if (Array.isArray(items?.gallery)) {
            const updatedGallery = items.gallery.map(formatGalleryItemData);
            setFiles(updatedGallery);
          }
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, customerConstants.MY_EVENTS_GALLERY));
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const getCustomerRecapFeedback = (eventGroupId) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.CUSTOMER_RECAP_FEEDBACK,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .getCustomerRecapFeedback(eventGroupId)
      .then(
        (response) => {
          dispatch(
            success(response, customerConstants.CUSTOMER_RECAP_FEEDBACK)
          );
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.CUSTOMER_RECAP_FEEDBACK,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const addCustomerRecapFeedback = (data, onResponseCallback) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.ADD_CUSTOMER_RECAP_FEEDBACK,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .addCustomerRecapFeedback(data)
      .then(
        (response) => {
          if (onResponseCallback) {
            onResponseCallback();
          }
          customToast(messages.SUBMIT_SUCCESSFULLY, toast.TYPE.SUCCESS);
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.ADD_CUSTOMER_RECAP_FEEDBACK,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};
// Get Events list by GroudId
const getAllEventsByGroupId = (eventGroupId) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.GET_ALL_EVENTS_BY_GROUP_ID,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .getAllEventsByGroupId(eventGroupId)
      .then(
        (response) => {
          if (response) {
            dispatch(
              custom(response, customerConstants.GET_ALL_EVENTS_BY_GROUP_ID)
            );
          }
        },
        (error) => {
          errorHandler(error);
          dispatch(
            failure(error, customerConstants.GET_ALL_EVENTS_BY_GROUP_ID)
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.GET_ALL_EVENTS_BY_GROUP_ID,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

//get list of invoices for a group
const getInvoiceList = (eventGroupId) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.GET_INVOICE_LIST,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    customerDashboardServices
      .getInvoiceList(eventGroupId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.GET_INVOICE_LIST));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.GET_INVOICE_LIST,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const resetAttendedEvent = () => {
  return (dispatch) => {
    dispatch(success(null, customerConstants.GET_SEARCH_RESULT));
  };
};

const resetInvoiceList = () => {
  return (dispatch) => {
    dispatch(success([], customerConstants.GET_INVOICE_LIST));
  };
};

export const customerDashboardActions = {
  myEvents,
  generateInvoice,
  cancelEvent,
  favoriteClip,
  referAFriend,
  resetMyEvents,
  myAccountInfo,
  lockFromGallery,
  extendSbCheckout,
  deleteFromGallery,
  getReviewFormData,
  updateMyAccountInfo,
  getAllEventsByGroupId,
  downloadSelectedFiles,
  getAccessGroupGallery,
  myEventsAccessGallery,
  updateCustomerPassword,
  submitRatingAndFeedback,
  getCustomerRecapFeedback,
  addCustomerRecapFeedback,
  attendedEventSearchResult,
  attendedEventRecentSearches,
  getTippedEventDetails,
  getExtendedEventDetails,
  getInvoiceList,
  resetAttendedEvent,
  resetInvoiceList,
};
